class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

const getApiBaseUrl = (): string => {
  return process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:3001';
};

const isNetworkError = (error: unknown): boolean => {
  if (error instanceof TypeError) {
    return true;
  }
  if (!(error instanceof Error)) {
    return false;
  }
  const message = error.message.toLowerCase();
  return message.includes('network') || message.includes('fetch') || message.includes('offline');
};

export class LeadSubmitNetworkError extends Error {
  constructor() {
    super('Connection failed. Please try again.');
    this.name = 'LeadSubmitNetworkError';
  }
}

export const submitPublicLead = async (payload: {
  fullName: string;
  email: string;
  companyName: string;
  phoneNumber?: string;
  teamSize?: string;
  notes?: string;
}): Promise<{
  success: boolean;
  lead_id: string;
  created_at: string | null;
  created_at_ist?: string | null;
  timezone?: string;
}> => {
  try {
    const response = await fetch(`${getApiBaseUrl()}/api/public/website-leads`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        full_name: payload.fullName,
        email: payload.email,
        company_name: payload.companyName,
        phone_number: payload.phoneNumber || '',
        team_size: payload.teamSize || '',
        notes: payload.notes || '',
      }),
    });

    let data: unknown = null;
    try {
      data = await response.json();
    } catch (_) {
      data = null;
    }

    if (!response.ok) {
      const message =
        data && typeof data === 'object' && data !== null && 'error' in data
          ? String((data as { error: unknown }).error)
          : `Request failed with status ${response.status}`;
      throw new ApiError(message, response.status);
    }

    return data as {
      success: boolean;
      lead_id: string;
      created_at: string | null;
      created_at_ist?: string | null;
      timezone?: string;
    };
  } catch (error) {
    if (isNetworkError(error)) {
      throw new LeadSubmitNetworkError();
    }
    throw error;
  }
};
